<template>
  <div @click.stop="selectComponent(model)" @contextmenu="onShowContextMenu" v-bind="$props" :id="model.$ID"
  :class="[ { 'dr-widget-list-editor-mode':isInEditorMode, 'dr-widget-list-selected' : isSelected}]">
    <portal to="action-buttons" v-if="isSelected">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn :disabled='readonly' v-on="on" text color="error" @click="onDeleteComponent">
            <font-awesome-icon :icon="['fal', 'trash-alt']" size="lg"/>
          </v-btn>
        </template>
        <span>{{ $t("vuetifyWidgets.common.remove") }}</span>
      </v-tooltip>
    </portal>
    <div class="label-widget-list">
      <span class="mdi mdi-format-list-bulleted label-widget-list-icon pr-1"></span>
      <span>widgetList: {{ model.Value }}</span> 
    </div> 
    <draggable
      v-if="isInEditorMode"
      :group="{ name:'container', put:['toolbox', 'container'] }"
      @add="onWidgetDraggableAdd"
      :swapThreshold="0.95"
      :emptyInsertThreshold="20"
      @update="onModelChanged"
      @change="onDraggableChanged"
      @start="onStartDraggable"
      :disabled="readonly"
      :list="model.Widgets"
    >
      <component
          v-for="widget in model.Widgets"
          :key="widget.$ID"
          :parentsWidgets="currentListOfParentsWidgets"
          :is="widget.$Type"
          :model="widget"
          @deleteComponent="onDeleteWidget"
        />
    </draggable>

    <!-- Контекстное меню -->
    <widgets-context-menu 
      v-if="isInEditorMode"
      v-model="showContextMenu" 
      :x="x" 
      :y="y"
      :snippetCreatable="!isInSnippetEditor"
      :widgetModel="model"
      @createSnippet="onCreateSnippet" 
      @deleteComponent="onDeleteComponentFromContextMenu"
      @pasteCopiedWidget="onPasteCopiedWidget"
    />
    <div v-if="needPagination"  class="d-flex justify-end align-center" >
      <div class=" d-flex justify-center align-baseline dr-widget-list-pagination-container dr-widget-list-editor-cursor">
        <div>{{$t('drWidgetList.itemsPerPage')}}:</div>
        <div class="ml-6 mr-6 d-flex dr-widget-list-pagination-select-container">
          <v-select
            class="dr-widget-list-select"
            height="20px"
            value="15"
            :items="['15']"
            color="black"
            disabled
          >
          </v-select>
        </div>
        1 - 15 {{$t('drWidgetList.of')}} 50
        <div class="ml-6">
          <v-btn small icon disabled ><v-icon>mdi-menu-left</v-icon></v-btn>
          <v-btn small icon disabled ><v-icon>mdi-menu-right</v-icon></v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import uk from '../../langs/widgetList/uk.json'
import ru from '../../langs/widgetList/ru.json'
import en from '../../langs/widgetList/en.json'
import mixin from '../../mixins/base-mixin'
import inputMixin from '../../mixins/input-mixin'
import contextMenuMixin from '../../mixins/contextmenu-mixin'
import jsonPatchMixin from '../../mixins/jsonPatchMixin'

export default {
  name: 'dr-widget-list-editor',
  mixins: [mixin, inputMixin, contextMenuMixin, jsonPatchMixin],
  provide: function () {
    return {
      // Переопределение getDataContract из dr-data-widget
      getDataContract: async function() {
        if (!this.getDataContract) {
          return {
            contractName: '',
            isSubObject: true
          }
        }
        var dataContract = await this.getDataContract()
        dataContract.isSubObject = true
        return dataContract
      }.bind(this)
    }
  },
  methods: {
    onModelChanged() {
      this.$emit('modelChanged', this.model)
    },

    onDeleteWidget(val) {
      this.model.Widgets = this.model.Widgets.filter(comp => comp != val)
      this.$emit('modelChanged', this.model)
      this.widgetsHelper.setSelectedWidget(undefined)
    },
    // Макет как выделеный виджет
    setSelectedWidget() {
      if (this.isInEditorMode) {
        this.widgetsHelper.setSelectedWidget(this.model)
      }
    }
  },
  computed: {
    needPagination() {
      return this.model.Pagination ? this.model.Pagination.NeedPagination : this.model.NeedPagination
    }
  },
  i18n: {
    messages: {
      uk,
      en,
      ru
    }
  }
}
</script>

<style>
.dr-widget-list-editor-mode {
  border: 1px solid rgb(0, 60, 255);
  min-height: 50px;
  padding: 10px;
  margin-top: 10px;
  margin-bottom: 10px;
}
.dr-widget-list-selected {
  outline: 2px solid #ffa500;
  outline-offset: -2px;
}
.dr-widget-list-editor-cursor {
  cursor: default;
}
.label-widget-list {
  background-color: #3e77db;
  font-size: 12px;
  color: #fff;
  margin: -10px -10px 0 -10px
}
</style>
